import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import FlagTeam from '@assets/images/placeholder/team-placeholder.svg'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import useWindowSize from '@shared/hooks/windowSize'
import CustomLink from '../customLink'
import useStatus from '@shared-submodule/sm-hooks/useStatus'
import { ENUM_CRICKET_MATCH_PAGES } from '@shared-submodule/sm-enum'
import { convertDt24h } from '@shared-submodule/utils'

const MyImage = dynamic(() => import('@shared/components/myImage'))

function LiveMatchCard({ data }) {
  const [width] = useWindowSize()
  const handleClick = value => {
    const { sStatusStr } = useStatus(value)
    const rewriteURLs = {}
    value?.oMatchSeos?.oSeo?.forEach(data => {
      if (data?.sSlug) {
        rewriteURLs[ENUM_CRICKET_MATCH_PAGES[data.eSubType]] = `/${data?.sSlug}`
      }
    })
    rewriteURLs.home = `/${value?.oSeo?.sSlug}`
    if (sStatusStr === 'live') return rewriteURLs?.commentary || rewriteURLs?.home
    else if (sStatusStr === 'scheduled') return rewriteURLs?.home || `/${value?.oSeo?.sSlug}`
    else if (sStatusStr === 'completed' || sStatusStr === 'cancelled') return rewriteURLs?.['full-scorecard'] || rewriteURLs?.home
  }

  const badgeColorDecide = data => {
    switch (data) {
      case 'live':
        return 'danger'
      default:
        return ''
    }
  }

  return (
    <div className={`${styles.liveMatchCardList} liveMatchCardList`}>
      {data.bScoreCard &&
        data?.aScore &&
        data.aScore?.map((item, index) => {
          const { sStatus, sStatusStr, sFormat } = useStatus(item)
          if (!item?.oSeries) {
            return null
          }
          return (
            <div
              key={index}
              className={`${styles.liveMatchCard} ${
                item?.idataegoryId === '623184baf5d229bacb01030e' && width < 992 ? 'd-none' : ''
              } position-relative`}
              onClick={() => handleClick(item)}>
              <CustomLink href={handleClick(item)} passHref>
                <a className={styles.scoreCardLink}></a>
              </CustomLink>

              <div className={`${styles.matchHeader} d-flex align-items-center justify-content-between`}>
                {sStatusStr === 'live' ? (
                  <span className={`${styles.liveStatus} ${badgeColorDecide(sStatusStr)}-text`}>
                    <span className={styles.pulse}></span>
                    {sStatus}
                  </span>
                ) : (
                  <span className={styles.matchInfo}>
                    {item?.sSubtitle}
                    {sFormat && `, ${sFormat}`} &middot; {convertDt24h(item?.dStartDate)}
                  </span>
                )}
              </div>

              <div className={`${styles.teamRow} ${item?.oTeamScoreA?.iTeamId === item?.iWinnerId ? styles.winner : ''} d-flex align-items-center justify-content-between`}>
                <div className={`${styles.teamInfo} d-flex align-items-center`}>
                  <div className={`${styles.teamImg} flex-shrink-0`}>
                    <MyImage
                      src={item?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${item?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : FlagTeam}
                      alt={item?.oTeamScoreA?.oTeam?.sAbbr}
                      blurDataURL={BLUR_DATA_URL_BASE64}
                      placeholder="blur"
                      width="20"
                      height="20"
                      autoRadiusImage
                    />
                  </div>
                  <b className={styles.teamAbbr}>{item?.oTeamScoreA?.oTeam?.sAbbr}</b>
                </div>
                <b className={styles.teamScore}>{item?.oTeamScoreA?.sScoresFull || ''}</b>
              </div>

              <div className={`${styles.teamRow} ${item?.oTeamScoreB?.iTeamId === item?.iWinnerId ? styles.winner : ''} d-flex align-items-center justify-content-between`}>
                <div className={`${styles.teamInfo} d-flex align-items-center`}>
                  <div className={`${styles.teamImg} flex-shrink-0`}>
                    <MyImage
                      src={item?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${item?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : FlagTeam}
                      alt={item?.oTeamScoreB?.oTeam?.sAbbr}
                      errorImage={FlagTeam}
                      blurDataURL={BLUR_DATA_URL_BASE64}
                      placeholder="blur"
                      width="20"
                      height="20"
                      autoRadiusImage
                    />
                  </div>
                  <b className={styles.teamAbbr}>{item?.oTeamScoreB?.oTeam?.sAbbr}</b>
                </div>
                <b className={styles.teamScore}>{item?.oTeamScoreB?.sScoresFull || ''}</b>
              </div>

              {item?.sStatusNote && (
                <p
                  className={`${styles.statusNote} ${
                    sStatusStr === 'completed' ? styles.success : sStatusStr === 'scheduled' ? styles.scheduled : ''
                  }`}>
                  {item?.sStatusNote}
                </p>
              )}
            </div>
          )
        })}
    </div>
  )
}

LiveMatchCard.propTypes = {
  data: PropTypes.object
}

export default LiveMatchCard
